module.exports = __webpack_public_path__ + "img/BIMB0340.a6a07ad0.png";